/*
 * Copyright (c) 2017 Payoneer Germany GmbH. All rights reserved.
 */

var vanillaTextMask = require('vanilla-text-mask');

function getGroupField(characterRegex, separator, maxLength, groupSize) {
    var mask = [];
    var remainLength = maxLength;
    if (
        !(characterRegex && separator && typeof maxLength === 'number' && typeof groupSize === 'number' && maxLength > 0 && groupSize > 0)
    ) {
        return mask;
    }
    while (remainLength > 0) {
        for (var j = 0; j < groupSize && remainLength > 0; j++) {
            mask.push(characterRegex);
            remainLength--;
        }
        if (remainLength > 0) {
            mask.push(separator);
        }
    }
    return mask;
}
function getCardNumberMask() {
    return getGroupField(/\d/, ' ', 19, 4);
}
function getIbanMask() {
    return getGroupField(/[A-Za-z0-9]/, ' ', 31, 4);
}
function formatField(inputField, type) {
    if (inputField === null) {
        return null;
    }
    var mask = type === 'iban' ? getIbanMask() : getCardNumberMask();

    vanillaTextMask.maskInput({
        inputElement: inputField,
        mask: mask,
        placeholderChar: '\u2000',
        guide: false,
    });
}

function formatCard(inputField) {
    formatField(inputField, 'cardNumber');
}
function formatIban(inputField) {
    formatField(inputField, 'iban');
}
module.exports = { formatCard: formatCard, formatIban: formatIban, getGroupField: getGroupField };
